export default __webpack_public_path__ + "assets/52e44829a3853b8de9dac775e180cf39.svg";